var singleSelectionControl = (function() {

    var $btnLabels = $('.btn-group-toggle label.btn');

    function onClick($containerElement) {

        if (typeof $containerElement == "undefined") {
            $containerElement = $(document);
        }

        $($btnLabels, $containerElement).click(function () {
            var $btnLabel = $(this);

            // Remove "active" class of all buttons of the group
            $btnLabel.siblings().removeClass('active').children().prop('checked', false);

            // Depending if the checkbox is checked or not, toggle or not the "active" class
            if(!$btnLabel.children().is(':checked')) {
                $btnLabel.children().prop('checked', true);
            } else {
                $btnLabel.removeClass('active');
                $btnLabel.children().prop('checked', false);
            }
        });
    };

    return {
        onClick: onClick
    }
})();
